import { Map as map } from 'immutable';
const C = require("../constants");

function QuestionDialogReducer(state = map(), action) {
    switch (action.type) {
        case C.SHOW_QUESTION_DIALOG:
            return action.data;
        default:
            return state;
    }
};

export default QuestionDialogReducer;


// WEBPACK FOOTER //
// ./src/reducers/QuestionDialogReducer.js